<template>
  <ErrorModal />
  <ChatOverview v-if="isChatOverviewVisible" />
  <div class="analytics-logs-tab-content">
    <DxDataGrid
      :data-source="moderationLogsConversations"
      :remote-operations="true"
      :key-expr="'conversationId'"
      :show-borders="true"
      :allow-column-resizing="true"
      column-resizing-mode="widget"
      no-data-text="No results"
      @exporting="onExporting"
    >
      <DxExport :enabled="true" />

      <DxColumn
        data-field="conversationId"
        data-type="string"
        caption="Conversation ID"
        :allow-sorting="false"
      />
      <DxColumn
        data-field="userId"
        data-type="string"
        caption="User ID"
        :allow-sorting="false"
      />
      <DxColumn
        data-field="username"
        data-type="string"
        caption="Username"
        :allow-sorting="false"
      />
      <DxColumn
        data-field="conversationStartedAt"
        data-type="Date"
        caption="Conversation started at"
        :allow-sorting="false"
        cell-template="startedAtCellTemplate"
      />
      <template #startedAtCellTemplate="rowData">
        <span>{{
          moment(rowData.data.data.conversationStartedAt).format(
            "MMMM Do YYYY, h:mm:ss A"
          )
        }}</span>
      </template>
      <DxColumn
        data-field="conversationTopic"
        data-type="string"
        caption="Topic"
        :allow-sorting="false"
      />
      <DxColumn
        caption="Actions"
        :buttons="conversationActionButtons"
        type="buttons"
      />
      <DxPaging :page-size="10" />
      <DxPager
        :visible="true"
        :allowed-page-sizes="[10, 20, 50, 'all']"
        display-mode="full"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="true"
      />
      <DxLoadPanel :enabled="true" />
    </DxDataGrid>
  </div>
</template>
<script setup>
import { ref, computed } from "vue";
import store from "../../../store/index";
import moment from "moment";
import {
  DxDataGrid,
  DxPager,
  DxPaging,
  DxColumn,
  DxLoadPanel,
  DxExport
} from "devextreme-vue/data-grid";
import ChatOverview from "./ChatOverview.vue";
import ErrorModal from "../ErrorModal.vue";
import createCustomStore from "../../../store/custom.store";
import aiService from "../../../services/ai.service";

const moderationLogsConversations = ref(
  createCustomStore(
    "/api/aiAssistantLogs/getModerationLogs",
    null,
    "conversationId"
  )
);

const conversationActionButtons = [
  {
    hint: "View messages",
    icon: "chat",
    onClick: e => displayMessagesFromConversation(e.row.data.conversationId)
  }
];

const isChatOverviewVisible = computed({
  get: () => store.state.aiAssistantLogs.isChatOverviewVisible
});

const displayMessagesFromConversation = async conversationId => {
  await aiService.getMessagesByConversation(conversationId);
  store.commit("aiAssistantLogs/displayChatOverviewPopup");
};

const onExporting = async e => {
  await aiService
    .exportModerationLogs()
    .then(response => {
      const fileURL = window.URL.createObjectURL(
        new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        })
      );
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);
      a.href = fileURL;
      a.download = "ModerationLogs.xlsx";
      a.click();
      window.URL.revokeObjectURL(fileURL);
      document.body.removeChild(a);
    })
    .catch(error => {
      console.error("Error downloading the file:", error);
    });
};
</script>
